import React, { useRef } from "react";
import { Text } from "@react-three/drei";
import { useThree, useFrame } from "@react-three/fiber";

/**
 * Kameraya doğru sürekli dönen 3D yazı bileşeni.
 * Panelin içinden veya dışından bakıldığında her zaman okunabilir kalır.
 */
const FacingText = ({
  position,
  children,
  fontSize = 0.05,
  color = "black",
  outlineColor,
  outlineWidth,
  ...props
}) => {
  const ref = useRef();
  const { camera } = useThree();

  useFrame(() => {
    if (ref.current) {
      ref.current.lookAt(camera.position);
    }
  });

  return (
    <Text
      ref={ref}
      position={position}
      fontSize={fontSize}
      color={color}
      anchorX="middle"
      anchorY="middle"
      outlineColor={outlineColor}
      outlineWidth={outlineWidth}
      {...props}
    >
      {children}
    </Text>
  );
};

export default FacingText;
